import React from 'react'
import Link from 'gatsby-link'

import ChevronRightIcon from '../assets/icons/chevron-right.svg'

const NavBreadCrumb = ({ currentRouteName }) => (
  <div className="breadcrumb">
    <Link to="">Support</Link>
    <img src={ChevronRightIcon} alt=">" className="chevron-right" />
    <span>{currentRouteName}</span>
  </div>
)

export default NavBreadCrumb



// WEBPACK FOOTER //
// ./src/components/NavBreadCrumb.js